/// <reference path="../../Common/Helpers/GridEditorDialog.ts" />

namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderProductsEditDialog extends Common.GridEditorDialog<OrderProductsRow> {
        protected getFormKey() { return OrderProductsForm.formKey; }
        protected getLocalTextPrefix() { return OrderProductsRow.localTextPrefix; }

        protected form = new OrderProductsForm(this.idPrefix);
       // protected form: OrderProductsForm;
        public stateIds: number;

        public OrderStatus: number;
        constructor() {
            super();
           
       
            this.form.ProductId.changeSelect2(e => {
                let productId = this.form.ProductId.value;
            
                let product = RioERP.Products.ProductsRow.getLookup().itemById[productId];
                if (product.ERioplayVersion != null)
                {
                    var eRioplayVersion = product.ERioplayVersion.toString();
                }
                this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                this.form.Rioplay8WatchTime.getGridField().toggle(false);
                this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                this.form.Rioplay8ValidDate.getGridField().toggle(false);
                this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                if (eRioplayVersion != '4') {
                    this.form.Rioplay8ProductCode.getGridField().toggle(false);
                    this.form.Rioplay8ESubscriptionType.getGridField().toggle(false);
                    this.form.Rioplay8EViewsType.getGridField().toggle(false);
                    this.form.Rioplay8EWatchTimetype.getGridField().toggle(false);
                    this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                    this.form.Rioplay8WatchTime.getGridField().toggle(false);
                    this.form.Rioplay8AllowedDevices.getGridField().toggle(false);
                    this.form.Rioplay8EDeviceRestrictionType.getGridField().toggle(false);
                    this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                    this.form.Rioplay8SwitchCount.getGridField().toggle(false);
                    this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                    this.form.Rioplay8ValidDate.getGridField().toggle(false);
                    this.form.Rioplay8TenantId.getGridField().toggle(false);
                    this.form.EOpens.getGridField().toggle(true);
                    this.form.EWatchTime.getGridField().toggle(true);
                    this.form.EValidityType.getGridField().toggle(true);
                    this.form.EValidity.getGridField().toggle(true);
                    this.form.ValidTill.getGridField().toggle(true);
                    this.form.AllowedDevice.getGridField().toggle(true);
                }
                else {
                   
                    if (eRioplayVersion == '4') {
                        this.form.Rioplay8ProductCode.getGridField().toggle(true);
                        this.form.Rioplay8ESubscriptionType.getGridField().toggle(true);
                        this.form.Rioplay8EViewsType.getGridField().toggle(true);
                        this.form.Rioplay8EWatchTimetype.getGridField().toggle(true);
                        this.form.Rioplay8AllowedDevices.getGridField().toggle(true);
                        this.form.Rioplay8EDeviceRestrictionType.getGridField().toggle(true);
                        this.form.Rioplay8SwitchCount.getGridField().toggle(true);
                        this.form.Rioplay8TenantId.getGridField().toggle(true);
                        this.form.EOpens.getGridField().toggle(false);
                        this.form.EWatchTime.getGridField().toggle(false);
                        this.form.EValidityType.getGridField().toggle(false);
                        this.form.EValidity.getGridField().toggle(false);
                        this.form.ValidTill.getGridField().toggle(false);
                        this.form.AllowedDevice.getGridField().toggle(false);
                    }
                    else {
                        this.form.EOpens.getGridField().toggle(true);
                        this.form.EWatchTime.getGridField().toggle(true);
                        this.form.EValidityType.getGridField().toggle(true);
                        this.form.EValidity.getGridField().toggle(true);
                        this.form.ValidTill.getGridField().toggle(true);
                        this.form.AllowedDevice.getGridField().toggle(true);
                        this.form.Rioplay8ProductCode.getGridField().toggle(false);
                        this.form.Rioplay8ESubscriptionType.getGridField().toggle(false);
                        this.form.Rioplay8EViewsType.getGridField().toggle(false);
                        this.form.Rioplay8EWatchTimetype.getGridField().toggle(false);
                        this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                        this.form.Rioplay8WatchTime.getGridField().toggle(false);
                        this.form.Rioplay8AllowedDevices.getGridField().toggle(false);
                        this.form.Rioplay8EDeviceRestrictionType.getGridField().toggle(false);
                        this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                        this.form.Rioplay8SwitchCount.getGridField().toggle(false);
                        this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                        this.form.Rioplay8ValidDate.getGridField().toggle(false);
                    }
                }
            });

            this.form.OrderProductSpecificationId.changeSelect2(e => {

                const rawValue = this.form.OrderProductSpecificationId?.value;

                if (!rawValue || rawValue.trim() === "")
                    return;

                
                const ProductSpecificationId = rawValue.indexOf(",") !== -1
                    ? rawValue.substring(rawValue.lastIndexOf(",") + 1).trim()
                    : rawValue.trim();
               
                let product = RioERP.Products.ProductSpecificationsRow.getLookup().itemById[ProductSpecificationId];
                if (product != null) {
                    if (!product.IsActive) {
                        this.form.OrderProductSpecificationId.value = null;
                        Q.notifyError("Product Specification is no longer active");
                        return;
                    }
                }
            });

            this.form.Rioplay8EViewsType.changeSelect2(e => {
                var eRioplay8EViewsType = this.form.Rioplay8EViewsType.value;
                this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                if (eRioplay8EViewsType == '1') {
                    this.form.Rioplay8ViewsPerContent.getGridField().toggle(true);
                }
                else if (eRioplay8EViewsType == '0') {
                    this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                }
            });
            this.form.Rioplay8EWatchTimetype.changeSelect2(e => {
                var eRioplay8EWatchTimetype = this.form.Rioplay8EWatchTimetype.value;
                this.form.Rioplay8WatchTime.getGridField().toggle(false);
                if (eRioplay8EWatchTimetype == '1') {
                    this.form.Rioplay8WatchTime.getGridField().toggle(true);
                }
                else if (eRioplay8EWatchTimetype == '0') {
                    this.form.Rioplay8WatchTime.getGridField().toggle(false);
                }
            });
            this.form.Rioplay8ESubscriptionType.changeSelect2(e => {
                var eRioplay8ESubscriptionType = this.form.Rioplay8ESubscriptionType.value;
                this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                this.form.Rioplay8ValidDate.getGridField().toggle(false);
                if (eRioplay8ESubscriptionType == '0') {
                    this.form.Rioplay8ValidityInDays.getGridField().toggle(true);
                }
                else if (eRioplay8ESubscriptionType == '1') {
                    this.form.Rioplay8ValidDate.getGridField().toggle(true);
                }
            });
            this.form.Rioplay8EDeviceRestrictionType.changeSelect2(e => {
                var eRioplay8EDeviceRestrictionType = this.form.Rioplay8EDeviceRestrictionType.value;
                this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                if (eRioplay8EDeviceRestrictionType == '0') {
                    this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                }
                else if (eRioplay8EDeviceRestrictionType == '1') {
                    this.form.Rioplay8DeviceCount.getGridField().toggle(true);
                }
            });
        }

        private seEntityDetails(totalTaxRate: number) {
            
            if (this.form.Quantity.value == null) {
                this.form.Quantity.value = 1;
            }
          //  this.form.TaxAmount.value = this.form.Amount.value * totalTaxRate / 100;

            //  this.form.Amount.value = this.form.Quantity.value * this.form.Cost.value;

        }
        private setProductDetails(details: Products.ProductsRow) {
            if (this.form.Quantity.value == null) {
                this.form.Quantity.value = 1;
            }
            /*this.form.Cost.value = details.Cost;*/
            if (details.EOpens != null)
                this.form.EOpens.value = details.EOpens.toString();
            if (details.EWatchTime != null)
                this.form.EWatchTime.value = details.EWatchTime.toString();
            if (details.EValidityType != null)
                this.form.EValidityType.value = details.EValidityType.toString();
            if (details.EValidity != null)
                this.form.EValidity.value = details.EValidity.toString();
            if (details.EAccessStatus != null)
                this.form.EAccessStatus.value = details.EAccessStatus.toString();
            if (details.ValidTill != null)
                this.form.ValidTill.value = details.ValidTill;
            if (details.HasBooks != null)
                this.form.HasBooks.value = details.HasBooks;
            if (details.HasPenDrive != null)
                this.form.HasPendrive.value = details.HasPenDrive;
            if (details.HasCourier != null)
                this.form.HasCourier.value = details.HasCourier;
            if (details.IsLive != null)
                this.form.IsLive.value = details.IsLive;
            if (details.DownloadUrl1 != null)
                this.form.DownloadUrl1.value = details.DownloadUrl1;
            if (details.DownloadUrl2 != null)
                this.form.DownloadUrl2.value = details.DownloadUrl2;
            if (details.TotalAllowedDuration != null)
                this.form.TotalAllowedDuration.value = details.TotalAllowedDuration;
            /*this.form.Amount.value = this.form.Quantity.value * this.form.Cost.value;*/

        }
        private setProductSpecificationDetails(details: Products.ProductSpecificationsRow) {
            debugger;
            if (details.Eopens != null)
                this.form.EOpens.value = details.Eopens.toString();
            if (details.EWatchtime != null)
                this.form.EWatchTime.value = details.EWatchtime.toString();
            if (details.EValidityType != null)
                this.form.EValidityType.value = details.EValidityType.toString();
            if (details.EValidity != null)
                this.form.EValidity.value = details.EValidity.toString();
            if (details.ValidTill != null)
                this.form.ValidTill.value = details.ValidTill;
            if (details.HasBooks != null)
                this.form.HasBooks.value = details.HasBooks;
            if (details.HasPendrive != null)
                this.form.HasPendrive.value = details.HasPendrive;         
            if (details.IsLive != null)
                this.form.IsLive.value = details.IsLive;
            if (details.AllowedDevices != null)
                this.form.AllowedDevice.value = details.AllowedDevices;
                //this.form.Cost.value = details.ProductCost ;
                //this.form.Amount.value = this.form.Cost.value * this.form.Quantity.value;  

        }
        //private setTaxRateDetails(detailsTaxRate: Masters.TaxRatesRow) {

        //    debugger;
        //    this.form.TaxAmount.value = this.form.Amount.value * detailsTaxRate.Rate / 100;

        //}        

        loadEntity(entity: OrderProductsRow) {
            super.loadEntity(entity);

            if (this.isNew()) {
                this.form.ValidTill.getGridField().toggle(false);
                this.form.EValidity.getGridField().toggle(false);
                this.form.Rioplay8ProductCode.getGridField().toggle(false);
                this.form.Rioplay8ESubscriptionType.getGridField().toggle(false);
                this.form.Rioplay8EViewsType.getGridField().toggle(false);
                this.form.Rioplay8EWatchTimetype.getGridField().toggle(false);
                this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                this.form.Rioplay8WatchTime.getGridField().toggle(false);
                this.form.Rioplay8AllowedDevices.getGridField().toggle(false);
                this.form.Rioplay8EDeviceRestrictionType.getGridField().toggle(false);
                this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                this.form.Rioplay8SwitchCount.getGridField().toggle(false);
                this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                this.form.Rioplay8ValidDate.getGridField().toggle(false);
                this.form.Rioplay8TenantId.getGridField().toggle(false);
            }
            else if (this.isEditMode())
            {
                this.form.ValidTill.getGridField().toggle(false);
                this.form.EValidity.getGridField().toggle(false);
                this.form.Rioplay8ProductCode.getGridField().toggle(false);
                this.form.Rioplay8ESubscriptionType.getGridField().toggle(false);
                this.form.Rioplay8EViewsType.getGridField().toggle(false);
                this.form.Rioplay8EWatchTimetype.getGridField().toggle(false);
                this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                this.form.Rioplay8WatchTime.getGridField().toggle(false);
                this.form.Rioplay8AllowedDevices.getGridField().toggle(false);
                this.form.Rioplay8EDeviceRestrictionType.getGridField().toggle(false);
                this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                this.form.Rioplay8SwitchCount.getGridField().toggle(false);
                this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                this.form.Rioplay8ValidDate.getGridField().toggle(false);
                this.form.Rioplay8TenantId.getGridField().toggle(false);
                let productId = this.form.ProductId.value;

                let product = RioERP.Products.ProductsRow.getLookup().itemById[productId];
                if (product.ERioplayVersion != null) {
                    var eRioplayVersion = product.ERioplayVersion.toString();
                }
                if (eRioplayVersion == '4') {
                    this.form.Rioplay8ProductCode.getGridField().toggle(true);
                    this.form.Rioplay8ESubscriptionType.getGridField().toggle(true);
                    this.form.Rioplay8EViewsType.getGridField().toggle(true);
                    this.form.Rioplay8EWatchTimetype.getGridField().toggle(true);
                    this.form.Rioplay8AllowedDevices.getGridField().toggle(true);
                    this.form.Rioplay8EDeviceRestrictionType.getGridField().toggle(true);
                    this.form.Rioplay8SwitchCount.getGridField().toggle(true);
                    this.form.Rioplay8TenantId.getGridField().toggle(true);
                    this.form.EOpens.getGridField().toggle(false);
                    this.form.EWatchTime.getGridField().toggle(false);
                    this.form.EValidityType.getGridField().toggle(false);
                    this.form.EValidity.getGridField().toggle(false);
                    this.form.ValidTill.getGridField().toggle(false);
                    this.form.AllowedDevice.getGridField().toggle(false);
                }
                else if (eRioplayVersion != '4')
                {
                    this.form.EOpens.getGridField().toggle(true);
                    this.form.EWatchTime.getGridField().toggle(true);
                    this.form.EValidityType.getGridField().toggle(true);
                    this.form.EValidity.getGridField().toggle(true);
                    this.form.ValidTill.getGridField().toggle(true);
                    this.form.AllowedDevice.getGridField().toggle(true);
                }
                var eRioplay8EViewsType = this.form.Rioplay8EViewsType.value;
                this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                if (eRioplay8EViewsType == '1') {
                    this.form.Rioplay8ViewsPerContent.getGridField().toggle(true);
                }
                else if (eRioplay8EViewsType == '0') {
                    this.form.Rioplay8ViewsPerContent.getGridField().toggle(false);
                }
                var eRioplay8EWatchTimetype = this.form.Rioplay8EWatchTimetype.value;
                this.form.Rioplay8WatchTime.getGridField().toggle(false);
                if (eRioplay8EWatchTimetype == '1') {
                    this.form.Rioplay8WatchTime.getGridField().toggle(true);
                }
                else if (eRioplay8EWatchTimetype == '0') {
                    this.form.Rioplay8WatchTime.getGridField().toggle(false);
                }
                var eRioplay8EDeviceRestrictionType = this.form.Rioplay8EDeviceRestrictionType.value;
                this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                if (eRioplay8EDeviceRestrictionType == '0') {
                    this.form.Rioplay8DeviceCount.getGridField().toggle(false);
                }
                else if (eRioplay8EDeviceRestrictionType == '1') {
                    this.form.Rioplay8DeviceCount.getGridField().toggle(true);
                } var eRioplay8ESubscriptionType = this.form.Rioplay8ESubscriptionType.value;
                this.form.Rioplay8ValidityInDays.getGridField().toggle(false);
                this.form.Rioplay8ValidDate.getGridField().toggle(false);
                if (eRioplay8ESubscriptionType == '0') {
                    this.form.Rioplay8ValidityInDays.getGridField().toggle(true);
                }
                else if (eRioplay8ESubscriptionType == '1') {
                    this.form.Rioplay8ValidDate.getGridField().toggle(true);
                }
            }
           
            if (this.form.SerialKey.value != "") {
                Serenity.EditorUtils.setReadonly(this.form.SerialKey.element, true);
            }
        }

    }



}